<div class="defaultAside aside-open slide-box-show">
    <a href="javascript:void(0)" class="closebtn" (click)="close()">&times;</a>

    <div class="page-header-banner">
        <h1>Edit {{overlayData.productType.name}} Configuration</h1>
    </div>

    <div class="p-4">
        <div *ngIf="currentTexture">
            <ul class="nav nav-tabs">
                <li
                    class="nav-item"
                    (click)="getTexture(ct, true)"
                    *ngFor="let f of configuration; let ct = index">
                    <a
                        [ngClass]="{'active' : currentTexture.id === f.id}"
                        class="nav-link">{{f.name}}</a>
                </li>
            </ul>
        </div>

        <ng-container *ngIf="currentTexture">

            <div class="d-flex align-items-center mt-3">
                <a (click)="toggleSupplied()">
                    <i
                       class="toggle fa"
                       [ngClass]="{
                       'fa-toggle-on text-success': currentTexture.supplied,
                       'fa-toggle-off' : !currentTexture.supplied}"></i>
                    Do you supply this product as {{currentTexture.name}}
                </a>
            </div>


            <ng-container *ngIf="currentTexture.supplied">

                <div class="d-flex align-items-center mt-3">
                    <a (click)="toggleAllowRandom()">
                        <i class="toggle fa" [ngClass]="{'fa-toggle-on text-success': currentTexture.allowRandom, 'fa-toggle-off' : !currentTexture.allowRandom}"></i>
                        Do you allow orders of random width/length?
                    </a>
                </div>

                <div class="d-flex align-items-center mt-3">
                    <a (click)="toggleAllowBespoke()">
                        <i class="toggle fa" [ngClass]="{'fa-toggle-on text-success': currentTexture.allowBespoke, 'fa-toggle-off' : !currentTexture.allowBespoke}"></i>
                        Do you allow bespoke orders?
                    </a>
                </div>

                <ng-container *ngIf="currentTexture.allowBespoke">
                    <div class="row mt-3">
                        <div class="col-6">
                            <div class="mb-3">
                                <label>Min Width</label>
                                <div class="input-group">
                                    <input type="number" class="form-control" (ngModelChange)="saveTexture()" [(ngModel)]="currentTexture.restrictions.width.min" />
                                    <div class="input-group-append">
                                        <span class="input-group-text">mm</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="mb-3">
                                <label>Max Width</label>
                                <div class="input-group">
                                    <input type="number" class="form-control" (ngModelChange)="saveTexture()" [(ngModel)]="currentTexture.restrictions.width.max" />
                                    <div class="input-group-append">
                                        <span class="input-group-text">mm</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-6">
                            <div class="mb-3">
                                <label>Min Length</label>
                                <div class="input-group">
                                    <input type="number" class="form-control" (ngModelChange)="saveTexture()" [(ngModel)]="currentTexture.restrictions.length.min" />
                                    <div class="input-group-append">
                                        <span class="input-group-text">mm</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="mb-3">
                                <label>Max Length</label>
                                <div class="input-group">
                                    <input type="number" class="form-control" (ngModelChange)="saveTexture()" [(ngModel)]="currentTexture.restrictions.length.max" />
                                    <div class="input-group-append">
                                        <span class="input-group-text">mm</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-6">
                            <div class="mb-3">
                                <label>Min Thickness</label>
                                <div class="input-group">
                                    <input type="number" class="form-control" (ngModelChange)="saveTexture()" [(ngModel)]="currentTexture.restrictions.height.min" />
                                    <div class="input-group-append">
                                        <span class="input-group-text">mm</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="mb-3">
                                <label>Max Thickness</label>
                                <div class="input-group">
                                    <input type="number" class="form-control" (ngModelChange)="saveTexture()" [(ngModel)]="currentTexture.restrictions.height.max" />
                                    <div class="input-group-append">
                                        <span class="input-group-text">mm</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </ng-container>



            <div class="mt-2" *ngIf="currentSubType">
                <ul class="nav nav-tabs">
                    <li
                        class="nav-item"
                        (click)="getSubType(cst)"
                        *ngFor="let st of currentTexture.subTypes; let cst = index">
                        <a
                            [ngClass]="{'active' : currentSubType.id === st.id}"
                            class="nav-link">{{st.name}}</a>
                    </li>
                </ul>
            </div>

            <div class="row mt-4" *ngIf="currentSubType">
                <div class="col-6 mb-3" *ngIf="overlayData.productType.allowEdgeFinishing">
                    <h4>Edge Finishes</h4>
                    <div *ngFor="let f of currentSubType.finishesEdge; let fei = index">
                        <a (click)="toggleFinishes('finishesEdge', fei)">
                            <i class="toggle fa" [ngClass]="{'fa-toggle-on text-success': f.selected, 'fa-toggle-off' : !f.selected}"></i>
                            {{f.name}}
                        </a>
                    </div>

                </div>
                <div class="col-6 mb-3" *ngIf="overlayData.productType.allowAdditionalFinish">
                    <h4>Additional Finishes</h4>
                    <div *ngFor="let f of currentSubType.finishesAdditional; let fai = index">
                        <a (click)="toggleFinishes('finishesAdditional', fai)">
                            <i class="toggle fa" [ngClass]="{'fa-toggle-on text-success': f.selected, 'fa-toggle-off' : !f.selected}"></i>
                            {{f.name}}
                        </a>
                    </div>

                </div>

                <div class="col-6 mb-3">
                    <h4>Top Finishes</h4>
                    <div *ngFor="let f of currentSubType.finishesTop; let fti = index">
                        <a (click)="toggleFinishes('finishesTop', fti)">
                            <i class="toggle fa" [ngClass]="{'fa-toggle-on text-success': f.selected, 'fa-toggle-off' : !f.selected}"></i>
                            {{f.name}}
                        </a>
                    </div>

                </div>
                <div class="col-6 mb-3" *ngIf="overlayData.productType.allowFinishBottom">
                    <h4>Underside Finishes</h4>
                    <div *ngFor="let f of currentSubType.finishesBottom; let fbi = index">
                        <a (click)="toggleFinishes('finishesBottom', fbi)">
                            <i class="toggle fa" [ngClass]="{'fa-toggle-on text-success': f.selected, 'fa-toggle-off' : !f.selected}"></i>
                            {{f.name}}
                        </a>
                    </div>
                </div>

                <div class="col-6 mb-3" *ngIf="overlayData.productType.allowTonneFinish">
                    <h4>Per Tonne Finishes</h4>
                    <div *ngFor="let f of currentSubType.finishesTonne; let fbi = index">
                        <a (click)="toggleFinishes('finishesTonne', fbi)">
                            <i class="toggle fa" [ngClass]="{'fa-toggle-on text-success': f.selected, 'fa-toggle-off' : !f.selected}"></i>
                            {{f.name}}
                        </a>
                    </div>
                </div>

            </div>

<!-- start of pricing -->
            <ng-container *ngIf="currentTexture.pricingMethod">
                <h4 class="mt-3">Pricing methods</h4>
                <ul class="nav nav-tabs">
                    <li class="nav-item" *ngFor="let method of currentTexture.pricingMethods">
                        <a class="nav-link" [ngClass]="{'active' : method.id === currentTexture.pricingMethod.id}" (click)="setPricingMethod(method)">
                            <i
                                class="fa fa-check"
                                [ngClass]="{'text-success' : method.active, 'text-light' : !method.active}"></i>
                                {{method.name}}
                        </a>
                    </li>
                </ul>


                <ng-container *ngIf="currentTexture.pricingMethod.id === 'ST'">
                    <div class="mt-3">
                        <h5 class="mt-3">Standard product pricing will be applied</h5>
                        <div class="d-flex align-items-center mt-3">
                            <a (click)="togglePricingMethodActive()">
                                <i
                                    class="toggle fa"
                                    [ngClass]="{'fa-toggle-on text-success': currentTexture.pricingMethod.active, 'fa-toggle-off' : !currentTexture.pricingMethod.active}"></i>
                                <span *ngIf="currentTexture.pricingMethod.active"> This pricing method is activated</span>
                                <span *ngIf="!currentTexture.pricingMethod.active"> This pricing method is not activated</span>
                            </a>
                        </div>

                        <div *ngIf="currentTexture.pricingMethod.active">
                            <app-standard-stone-pricing [costGroups]="currentTexture.standardPricing"></app-standard-stone-pricing>
                        </div>

                    </div>
                </ng-container>


                <ng-container *ngIf="currentTexture.pricingMethod.id === 'CM'">
                    <div class="mt-3">
                        <h5 class="mt-3">This product pricing will be calculated from a base cubic metre cost of {{overlayData.range.baseCost | currency: 'GBP'}}</h5>
                        <div class="d-flex align-items-center mt-3">
                            <a (click)="togglePricingMethodActive()">
                                <i
                                    class="toggle fa"
                                    [ngClass]="{'fa-toggle-on text-success': currentTexture.pricingMethod.active, 'fa-toggle-off' : !currentTexture.pricingMethod.active}"></i>
                                <span *ngIf="currentTexture.pricingMethod.active"> This pricing method is activated</span>
                                <span *ngIf="!currentTexture.pricingMethod.active"> This pricing method is not activated</span>
                            </a>
                        </div>
                    </div>

                </ng-container>

                <ng-container *ngIf="currentTexture.pricingMethod.id === 'PSM'">
                    <div class="mt-3">
                        <h5 class="mt-3">Product pricing will be calculated from the parameters below</h5>
                        <div class="d-flex align-items-center mt-3">
                            <a (click)="togglePricingMethodActive()">
                                <i
                                    class="toggle fa"
                                    [ngClass]="{'fa-toggle-on text-success': currentTexture.pricingMethod.active, 'fa-toggle-off' : !currentTexture.pricingMethod.active}"></i>
                                <span *ngIf="currentTexture.pricingMethod.active"> This pricing method is activated</span>
                                <span *ngIf="!currentTexture.pricingMethod.active"> This pricing method is not activated</span>
                            </a>
                        </div>
                    </div>

                    <ng-container *ngIf="currentTexture.pricingMethod.active">
                        <ng-container *ngIf="currentTexture && overlayData.productType.sellUnits.length">
                            <div class="mt-3" style="border-bottom: 1px solid #CCC">

                                <ul class="nav nav-tabs">
                                    <li
                                        class="nav-item"
                                        (click)="setPricingGroup('random')">
                                        <a
                                            [ngClass]="{'active' : currentPricingGroup === 'random'}"
                                            class="nav-link">Random</a>
                                    </li>
                                    <li
                                        class="nav-item"
                                        (click)="setPricingGroup('setWidthRandom')">
                                        <a
                                            [ngClass]="{'active' : currentPricingGroup === 'setWidthRandom'}"
                                            class="nav-link">Set Width Random Length</a>
                                    </li>
                                    <li
                                        class="nav-item"
                                        (click)="setPricingGroup('setWidthSetLength')">
                                        <a
                                            [ngClass]="{'active' : currentPricingGroup === 'setWidthSetLength'}"
                                            class="nav-link">Set Width Set Length</a>
                                    </li>
                                </ul>
                                <div class="row mt-3" *ngFor="let o of currentTexture.costsSQM[currentPricingGroup]; let prIndex = index">
                                    <div class="col-3">
                                        <input [(ngModel)]="o.minThickness" (ngModelChange)="saveTexture()" type="number" class="form-control bordered mb-1" [placeholder]="'From'" />
                                    </div>
                                    <div class="col-3">
                                        <input [(ngModel)]="o.maxThickness" (ngModelChange)="saveTexture()" type="number" class="form-control bordered mb-1" [placeholder]="'To'" />
                                    </div>
                                    <div class="col-5">
                                        <input [(ngModel)]="o.cost" (ngModelChange)="saveTexture()" type="number" class="form-control bordered mb-1" [placeholder]="'Price'" />
                                    </div>
                                    <div class="col-1">
                                        <a (click)="removeRangeRow(currentTexture.costsSQM[currentPricingGroup], prIndex)">
                                            <img src="assets/images/icon-trash.svg" class="product-range-config-trash">
                                        </a>
                                    </div>
                                </div>
                                <div class="text-end mt-2 mb-3">
                                    <button class="btn btn-round btn-slim btn-primary" (click)="addRangeRow(currentTexture.costsSQM[currentPricingGroup])">
                                        <i class="fa fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </ng-container>


                    </ng-container>
                </ng-container>

            </ng-container>
            </ng-container>


            </ng-container>





        <div class="row mt-4">
            <div class="col-6">
                <button
                    type="button"
                    class="btn btn-round btn-primary-reverse"
                    (click)="confirmCancel()">
                    Cancel
                </button>
            </div>
            <div class="col-6 text-end">
                <button type="button" class="btn btn-round btn-primary" (click)="submit()">
                    Submit
                </button>
            </div>
        </div>

    </div>
</div>

<app-confirmation
    *ngIf="this.confirmationData.open"
    [data]="confirmationData"
    (complete)="confirmationComplete($event)"></app-confirmation>
